export default new class ElementService {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    public querySelector<E extends Element = Element>(selectors: string): E {
        const element = document.querySelector<E>(selectors);

        if (element === null) {
            throw new Error(`Element for selector ${selectors} not found.`);
        }

        return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    public elementQuerySelector<E extends Element = Element>(parentElement: Element, selectors: string): E {
        const element = parentElement.querySelector<E>(selectors);

        if (element === null) {
            throw new Error(`Element for selector ${selectors} not found.`);
        }

        return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    public closest<E extends Element = Element>(element: Element, selectors: string): E {
        const closestElement = element.closest<E>(selectors);

        if (closestElement === null) {
            throw new Error(`Closest element for selector ${selectors} not found.`);
        }

        return closestElement;
    }

    public elementData(element: HTMLElement, dataField: string): string {
        const dataValue = element.dataset[dataField];

        if (dataValue === undefined) {
            throw new Error(`Data field ${dataField} not found.`);
        }

        return dataValue;
    }

    public readIntNullInputValue(selectors: string): number | undefined {
        const inputElementValue = this.querySelector<HTMLInputElement>(selectors).value;

        if (inputElementValue === "") {
            return undefined;
        }

        return Number.parseInt(inputElementValue);
    }
}();
